import { Point } from './types.js';

/**
    @function pointRotate
    @desc Rotates a point around a given origin.
    @param {Array} p The point to be rotated, which should always be an `[x, y]` formatted Array.
    @param {Number} alpha The angle in radians to rotate.
    @param {Array} [origin = [0, 0]] The origin point of the rotation, which should always be an `[x, y]` formatted Array.
    @returns {Boolean}
*/
export const pointRotate = (p: Point, alpha: number, origin: Point = [0, 0]): Point => {
  const cosAlpha: number = Math.cos(alpha);
  const sinAlpha: number = Math.sin(alpha);
  const xshifted: number = p[0] - origin[0];
  const yshifted: number = p[1] - origin[1];

  return [
    cosAlpha * xshifted - sinAlpha * yshifted + origin[0],
    sinAlpha * xshifted + cosAlpha * yshifted + origin[1],
  ];
};
